import { render } from "./TrfModalCadastroGrupo.vue?vue&type=template&id=49d59549&scoped=true"
import script from "./TrfModalCadastroGrupo.vue?vue&type=script&lang=js"
export * from "./TrfModalCadastroGrupo.vue?vue&type=script&lang=js"

import "./TrfModalCadastroGrupo.vue?vue&type=style&index=0&id=49d59549&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d59549"],['__file',"src/components/Modal/TrfModalCadastroGrupo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49d59549"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49d59549', __exports__)) {
    console.log('reload')
    api.reload('49d59549', __exports__)
  }
  
  module.hot.accept("./TrfModalCadastroGrupo.vue?vue&type=template&id=49d59549&scoped=true", () => {
    console.log('re-render')
    api.rerender('49d59549', render)
  })

}


export default __exports__